namespace Matrix.DataAudit {
    export interface SecurityHistoryRow {
        SecurityKey?: number;
        SecurityId?: number;
        SecurityCode?: string;
        Name?: string;
        Generation?: number;
        IsCurrent?: string;
        DateFrom?: string;
        DateTo?: string;
        CurrentFrom?: string;
        CurrentTo?: string;
        DealParentCode?: string;
        SecurityTypeCode?: string;
        LocalCurrencyCode?: string;
        AssociatedAccountCode?: string;
        Sedol?: string;
        RIC?: string;
        Isin?: string;
        Cusip?: string;
        Figi?: string;
        Ticker?: string;
        InternalSecurityCode?: string;
        Issuer?: string;
        CouponRate?: number;
        MaturityDate?: string;
        SpLtRating?: string;
        SpStRating?: string;
        MoodysLtRating?: string;
        MoodysStRating?: string;
        FitchLtRating?: string;
        FitchStRating?: string;
        InternalLtRating?: string;
        InternalStRating?: string;
        CountryOfIssueCode?: string;
        CountryOfRiskCode?: string;
        CurrencyOfRiskCode?: string;
        TradeDate?: string;
        EffectiveDate?: string;
        BrokerCode?: string;
        BrokerName?: string;
        Strategy?: string;
        OptionStyle?: string;
        ExerciseStyle?: string;
        PutOrCall?: string;
        StrikePrice?: number;
        StrikeCurrency?: string;
        Premium?: number;
        PremiumCcy?: string;
        PayOrRec?: string;
        FixedOrFloat?: string;
        FloatIndex?: string;
        InflationIndexLag?: string;
        InterestTerm?: string;
        Spread?: number;
        AllIn?: number;
        InterestCcy?: string;
        PaymentFrequency?: string;
        PaymentBusDayConvention?: string;
        PaymentCalendar?: string;
        FirstPaymentDate?: string;
        DayCountBasis?: string;
        ResetFrequency?: string;
        ResetBusDayConvention?: string;
        ResetCalendar?: string;
        UnderlyerName?: string;
        UnderlyerCcy?: string;
        UnderlyerType?: string;
        ClearerReference?: string;
        RedCode?: string;
        CreditEvents?: string;
        Guarantor?: string;
        BorrowerCode?: string;
        Status?: string;
        RowId?: number;
        Version?: number;
        SourceCreatedBy?: string;
        SourceCreatedWhen?: string;
        SourceUpdatedBy?: string;
        SourceUpdatedWhen?: string;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace SecurityHistoryRow {
        export const idProperty = 'SecurityKey';
        export const nameProperty = 'SecurityCode';
        export const localTextPrefix = 'DataAudit.SecurityHistory';
        export const deletePermission = 'Read:SecurityHistory';
        export const insertPermission = 'DataAdmin:SecurityHistory';
        export const readPermission = 'Read:SecurityHistory';
        export const updatePermission = 'NoPermission';

        export declare const enum Fields {
            SecurityKey = "SecurityKey",
            SecurityId = "SecurityId",
            SecurityCode = "SecurityCode",
            Name = "Name",
            Generation = "Generation",
            IsCurrent = "IsCurrent",
            DateFrom = "DateFrom",
            DateTo = "DateTo",
            CurrentFrom = "CurrentFrom",
            CurrentTo = "CurrentTo",
            DealParentCode = "DealParentCode",
            SecurityTypeCode = "SecurityTypeCode",
            LocalCurrencyCode = "LocalCurrencyCode",
            AssociatedAccountCode = "AssociatedAccountCode",
            Sedol = "Sedol",
            RIC = "RIC",
            Isin = "Isin",
            Cusip = "Cusip",
            Figi = "Figi",
            Ticker = "Ticker",
            InternalSecurityCode = "InternalSecurityCode",
            Issuer = "Issuer",
            CouponRate = "CouponRate",
            MaturityDate = "MaturityDate",
            SpLtRating = "SpLtRating",
            SpStRating = "SpStRating",
            MoodysLtRating = "MoodysLtRating",
            MoodysStRating = "MoodysStRating",
            FitchLtRating = "FitchLtRating",
            FitchStRating = "FitchStRating",
            InternalLtRating = "InternalLtRating",
            InternalStRating = "InternalStRating",
            CountryOfIssueCode = "CountryOfIssueCode",
            CountryOfRiskCode = "CountryOfRiskCode",
            CurrencyOfRiskCode = "CurrencyOfRiskCode",
            TradeDate = "TradeDate",
            EffectiveDate = "EffectiveDate",
            BrokerCode = "BrokerCode",
            BrokerName = "BrokerName",
            Strategy = "Strategy",
            OptionStyle = "OptionStyle",
            ExerciseStyle = "ExerciseStyle",
            PutOrCall = "PutOrCall",
            StrikePrice = "StrikePrice",
            StrikeCurrency = "StrikeCurrency",
            Premium = "Premium",
            PremiumCcy = "PremiumCcy",
            PayOrRec = "PayOrRec",
            FixedOrFloat = "FixedOrFloat",
            FloatIndex = "FloatIndex",
            InflationIndexLag = "InflationIndexLag",
            InterestTerm = "InterestTerm",
            Spread = "Spread",
            AllIn = "AllIn",
            InterestCcy = "InterestCcy",
            PaymentFrequency = "PaymentFrequency",
            PaymentBusDayConvention = "PaymentBusDayConvention",
            PaymentCalendar = "PaymentCalendar",
            FirstPaymentDate = "FirstPaymentDate",
            DayCountBasis = "DayCountBasis",
            ResetFrequency = "ResetFrequency",
            ResetBusDayConvention = "ResetBusDayConvention",
            ResetCalendar = "ResetCalendar",
            UnderlyerName = "UnderlyerName",
            UnderlyerCcy = "UnderlyerCcy",
            UnderlyerType = "UnderlyerType",
            ClearerReference = "ClearerReference",
            RedCode = "RedCode",
            CreditEvents = "CreditEvents",
            Guarantor = "Guarantor",
            BorrowerCode = "BorrowerCode",
            Status = "Status",
            RowId = "RowId",
            Version = "Version",
            SourceCreatedBy = "SourceCreatedBy",
            SourceCreatedWhen = "SourceCreatedWhen",
            SourceUpdatedBy = "SourceUpdatedBy",
            SourceUpdatedWhen = "SourceUpdatedWhen",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
